import { render } from "./HeroiconsSolidChat.vue?vue&type=template&id=9c9eb924"
const script = {}

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChat.vue"]])

export default __exports__